<script setup>
import { computed } from 'vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  idPrefix: {
    type: String,
    required: true,
  },
  value: {
    default: null,
    validator: value => value === true || value === false || value === null,
  },
  title: {
    type: String,
    default: '',
  },
  help: {
    type: String,
    default: '',
  },
  states: {
    type: Object,
    required: true,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  loadingLabel: {
    type: String,
    required: true,
  },
  dataTarget: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['change']);

const options = computed(() => [
  { key: 'disabled', value: false, label: props.states.disabled },
  {
    key: 'not-configured',
    value: null,
    label: props.states.notConfigured,
  },
  { key: 'enabled', value: true, label: props.states.enabled },
]);
</script>

<template>
  <div class="flex flex-col gap-3" :data-target="dataTarget || undefined">
    <div v-if="title || help" class="flex flex-col gap-1">
      <p v-if="title" class="mb-0 text-sm font-medium text-n-slate-12">
        {{ title }}
      </p>
      <p v-if="help" class="mb-0 text-sm text-n-slate-11">
        {{ help }}
      </p>
    </div>

    <div class="flex flex-col gap-2">
      <div
        v-for="option in options"
        :key="option.key"
        class="flex items-center gap-2"
      >
        <input
          :id="`${idPrefix}-${option.key}`"
          type="radio"
          :name="idPrefix"
          :checked="value === option.value"
          :disabled="disabled || loading"
          @change="emit('change', option.value)"
        />
        <label
          :for="`${idPrefix}-${option.key}`"
          class="text-sm text-n-slate-12"
        >
          {{ option.label }}
        </label>
      </div>
    </div>

    <NextButton v-if="loading" :label="loadingLabel" is-loading />
  </div>
</template>
